<template>
  <div class="ouer-uploader" :class="{'is-error': hasError}" :style="{width: size, height: size}">
    <template v-if="imageUrl">
      <el-image class="upload-image" :src="imageUrl" :preview-src-list="[imageUrl]" fit="cover" />
      <div v-if="!disabled" class="clear-button" @click.stop="onClear">
        <i class="el-icon-circle-close" />
      </div>
    </template>
    <el-upload
      v-else
      action="#"
      accept="image/*"
      class="avatar-uploader"
      :show-file-list="false"
      :disabled="disabled"
      :on-change="onSelect"
      :http-request="onRequest"
    >
      <i class="el-icon-plus avatar-uploader-icon" />
    </el-upload>
    <div v-if="hasError" class="upload-error">{{ errMessage }}</div>
  </div>
</template>

<script>
export default {
  name: 'OuerUploader',
  emits: ['change', 'input'],
  props: {
    disabled: Boolean,
    size: {
      type: [Number, String],
      default: '132px'
    },
    limit: {
      type: Number,
      default: 1
    },
    value: {
      type: Object,
      default: () => {}
    },
    hasError: Boolean,
    errMessage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imageUrl: ''
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newInfo) {
        this.imageUrl = newInfo?.url
      }
    }
  },
  methods: {
    onSelect(file) {
      if (file) {
        this.imageUrl = URL.createObjectURL(file.raw)
      }
    },
    onRequest(form) {
      const data = new FormData()
      data.append('file', form.file)
      data.append('name', form.file.name)
      data.append('fileSize', form.file.size)
      data.append('fileType', form.file.type)

      this.$emit('input', Object.assign({}, this.value, { url: this.imageUrl, file: data, changed: true }))
      this.$emit('change')
    },
    onClear() {
      this.$confirm('确定删除该图片？', '温馨提示', { type: 'warning' }).then(() => {
        this.$emit('input', Object.assign({}, this.value, { url: '', file: null, changed: true }))
        this.$emit('change')
        this.imageUrl = ''
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.ouer-uploader {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 18px;
  border-radius: 5px;
  padding: 4px;
  &::before {
    position: absolute;
    content: '';
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    border-radius: 5px;
    border: 1px dashed #dcdfe6;
  }
  &.is-error {
    &::before {
      border-color: #ff4949;
    }
    ::v-deep {
      .avatar-uploader .el-upload {
        border-color: #ff4949;
        .avatar-uploader-icon {
          color: #ff4949;
        }
      }
    }
  }
}
.upload-error {
  position: absolute;
  top: 100%;
  left: 0;
  color: #ff4949;
  font-size: 12px;
  line-height: 1;
  padding-top: 2px;
}
.upload-image {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 5px;
  ::v-deep .el-image__inner {
    object-position: left top;
  }
}
.clear-button {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -10px;
  right: -8px;
  z-index: 9;
  width: 28px;
  height: 28px;
  color: #999;
  font-size: 26px;
  border-radius: 50%;
  background-color: #fff;
}
</style>
